<template>
  <div>
    <div>
      <div class="widget-container">
        <DxFileUploader
          :id="`uploaderContainer${masterDetailData.data.id}`"
          :ref="dxFileUploader"
          accept="*"
          :multiple="true"
          upload-mode="useButtons"
          selectButtonText="Select File"
          :show-file-list="false"
          labelText=""
          @uploaded="onUploaded"
          @upload-error="onUploadError"
          @value-changed="onValueChanged"
          :visible="false"
        />
      </div>

      <v-row align="center" class="mb-1 innerGrid" no-gutters>
        <i-card-top class="d-md-flex" :useBtnList="buttonUseList" @btnUpload="btnUpload(masterDetailData)" @btnDelete="btnDelete()">
          <v-spacer />
          <template v-slot:body>
            <div></div>
          </template>
        </i-card-top>
      </v-row>
      <v-col cols="12" md="12" class="row pa-0">
        <v-col cols="12" lg="12" class="mt-0 pa-0">
          <DxDataGrid
            id="fileDataGrid"
            class="layout-col-height4-body"
            width="100%"
            height="250px"
            :ref="dxFileDataGridRef"
            :data-source="files"
            :remote-operations="false"
            :hover-state-enabled="true"
            :allow-column-resizing="true"
            :allow-column-reordering="true"
            :row-alternation-enabled="true"
            :column-auto-width="true"
            :show-borders="true"
            :show-row-lines="true"
            :focused-row-enabled="true"
            :column-hiding-enabled="false"
            key-expr="id"
            key="fileId"
            @editing-start="onEditingStart"
            @row-updating="onRowUpdating"
            @content-ready="onContentReady"
            @focused-row-changed="onFocusedRowChanged"
          >
            <DxPaging :enabled="true" :page-size="5" />
            <DxPager :visible="true" :allowed-page-sizes="[5, 'all']" />

            <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />

            <DxScrolling row-rendering-mode="standard" />

            <DxSelection :select-all-mode="allMode" show-check-boxes-mode="always" mode="multiple" />

            <DxColumn data-field="createdAt" data-type="date" caption="등록일자" format="yyyy.MM.dd HH:mm:ss" width="200px" alignment="center" />

            <DxColumn data-field="fileNm" caption="파일명" data-type="string" cell-template="fileTemplate" />
            <template #fileTemplate="{data: cellInfo}">
              <div class="d-flex">
                <div :title="cellInfo.value">
                  {{ cellInfo.value }}
                </div>
                <div v-if="cellInfo.row.data.extension != null">.{{ cellInfo.row.data.extension }}</div>
              </div>
            </template>

            <DxColumn
              data-field="extension"
              caption="확장자"
              width="60px"
              data-type="string"
              alignment="center"
              cell-template="extensionIconTemplate"
              :allow-editing="false"
            />

            <DxColumn data-field="fileSize" caption="용량" width="80px" data-type="string" alignment="right" />

            <DxColumn data-field="filePath" caption="경로" data-type="string" width="250px" />

            <DxColumn data-field="useYn" width="70px" data-type="boolean" caption="사용" edit-cell-template="checkBoxEditor" />

            <DxColumn
              data-field="__created__"
              caption="다운로드"
              data-type="string"
              alignment="center"
              width="80px"
              cell-template="downloadTemplate"
              :allow-sorting="false"
              :allow-editing="false"
            />

            <template #checkBoxEditor="{ data: cellInfo }">
              <DxCheckBox :value="cellInfo.value == 'Y' ? true : false" :onValueChanged="value => onCheckValueChanged(value, cellInfo)" />
            </template>

            <template #downloadTemplate="{ data : cellInfo }">
              <v-btn elevation="0" color="btn_sub" dark x-small v-if="cellInfo.value == null" @click="fileDownload(cellInfo.data)">
                다운로드
              </v-btn>
            </template>

            <template #extensionIconTemplate="{ data:cellInfo }">
              <svg-icon class="excel_icon file_icon" v-if="cellInfo.value == 'xlsx' || cellInfo.value == 'xls'" icon-class="excel" />

              <svg-icon class="jpg_icon file_icon" v-else-if="cellInfo.value == 'jpg'" icon-class="jpg" />

              <svg-icon class="pdf_icon file_icon" v-else-if="cellInfo.value == 'pdf'" icon-class="pdf" />

              <svg-icon class="png_icon file_icon" v-else-if="cellInfo.value == 'png'" icon-class="png" />

              <svg-icon class="txt_icon file_icon" v-else-if="cellInfo.value == 'txt'" icon-class="txt" />

              <svg-icon class="ppt_icon file_icon" v-else-if="cellInfo.value == 'ppt' || cellInfo.value == 'pptx'" icon-class="ppt" />

              <svg-icon class="zip_icon file_icon" v-else-if="cellInfo.value == 'zip' || cellInfo.value == 'cab'" icon-class="zip" />

              <svg-icon class="doc_icon file_icon" v-else-if="cellInfo.value == 'doc' || cellInfo.value == 'docx'" icon-class="doc" />

              <svg-icon class="hwp_icon file_icon" v-else-if="cellInfo.value == 'hwp' || cellInfo.value == 'hwpx'" icon-class="hwp" />

              <svg-icon class="file_default_icon file_icon" v-else icon-class="file_default" />
            </template>
          </DxDataGrid>
        </v-col>
      </v-col>
    </div>
  </div>
</template>

<script>
import { DxMasterDetail } from 'devextreme-vue/data-grid'
import { DxFileUploader } from 'devextreme-vue/file-uploader'
import { getFile, deleteFile, downloadFile } from '@/api/baseManage/fileUpload'
import notify from 'devextreme/ui/notify'
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가
  components: {
    DxMasterDetail,
    DxFileUploader
  },
  props: {
    masterDetailData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      buttonUseList: [
        'btnUpload', //업로드
        'btnDelete' //삭제
      ],
      maxFileSize: 1073741824,
      dxFileDataGridRef: 'fileDataGrid',
      dxFileUploader: 'uploaderContainer',
      files: [],
      allMode: 'allPages'
    }
  },
  computed: {
    fileUploader: function() {
      return this.$refs[this.dxFileUploader].instance
    },
    fileGridData: function() {
      return this.$refs[this.dxFileDataGridRef].instance
    }
  },
  beforeMount() {
    if (this.getCompId() == undefined) this.vToastify(this.$t('msgNoReqConditionsComp'), 'error')
    let searchParams = {
      targetId: this.masterDetailData.data.classifNo,
      targetType: this.masterDetailData.data.areaCd,
      compId: this.getCompId()
    }

    getFile(searchParams)
      .then(res => {
        if (res.success) {
          this.files = []
          this.files = res.list
        }
      })
      .catch(error => {})
      .finally(() => {})
  },
  created() {},
  mounted() {
    this.fileGridData.option('defaultPaging', false)
  },
  methods: {
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    btnUpload(e) {
      let uploadButton = document.querySelector(`#uploaderContainer${this.masterDetailData.data.id} .dx-button-content`)
      uploadButton.click()
    },
    async btnDelete() {
      var selectedRows = await this.fileGridData.getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.vToastify(this.$t('selectionData'), 'warn')
        return
      }

      this.fileRemove(selectedRows)
    },
    ///////////////////////////////////////
    /*         Uploader   Event          */
    ///////////////////////////////////////
    onUploaded(e) {
      e.component._files.forEach((element, index) => {
        if (element._isLoaded) {
          this.fileUploader.removeFile(index)
        }
      })
      notify(this.$t('파일이 업로드 되었습니다.'), 'success', 300)
    },
    onUploadError(e) {
      e.component._files.forEach((element, index) => {
        if (element._isError) {
          this.fileUploader.removeFile(index)
          notify(this.$t('파일을 업로드 할 수 없습니다.'), 'error', 300)
        }
      })
    },
    onValueChanged(e) {
      e.component._uploadButton._$element.remove()

      for (const element of e.value) {
        if (element.size >= this.maxFileSize) {
          notify(this.$t('파일이 용량이 1GB를 초과했습니다.'), 'error', 300)
          continue
        }
        let subFileName = this.getExtension(element.name)
        if (subFileName[0].length > 200) {
          notify(this.$t('파일의 이름이 200자 이상입니다.'), 'error', 300)
          continue
        }

        let newRow = {
          id: this.files.length + 1,
          fileId: this.files.length + 1,
          file: element,
          fileNm: subFileName[0],
          extension: subFileName[1],
          fileSize: this.getfileSize(element.size),
          useYn: 'Y',
          targetId: this.masterDetailData.data.classifNo,
          targetType: this.masterDetailData.data.areaCd,
          compId: this.getCompId()
        }

        Object.defineProperty(newRow, '__created__', { value: true, writable: true, enumerable: true, configurable: true })
        this.fileGridData.newRow(newRow)
      }

      e.value.splice(0)
    },
    fileRemove(files) {
      this.vToastifyPrompt(
        this.$t('doDeleteData'),
        'info',
        current => {
          let dbDeleteData = files.filter(element => !element.__created__)

          if (dbDeleteData.length != 0) {
            this.openLoading('deleting')
            deleteFile(files, true)
              .then(res => {
                if (res.success) {
                  this.gridInit()
                  this.search()
                }
              })
              .catch(error => {})
              .finally(() => {
                this.endLoading()
              })
          } else {
            this.gridInit()
            this.search()
          }
        },
        null,
        true
      )
    },
    fileDownload(rowData) {
      this.openLoading()
      // api 에 responseType: "blob" 필수, 백단에 byteArray(Blob)형태로 보내고 있기 때문
      downloadFile(rowData.fileId)
        .then(res => {
          let link = document.createElement('a')
          // 객체를 만들어서 생성
          let objectUrl = window.URL.createObjectURL(res)
          link.href = objectUrl
          link.download = `${rowData.fileNm}.${rowData.extension}`
          link.click()
        })
        .finally(() => this.endLoading())
    },

    ///////////////////////////////////////
    /*         DataGrid   Event          */
    ///////////////////////////////////////
    onRowUpdating(e) {
      this.fileGridData.selectRows(e.key, true)
    },
    onEditingStart(e) {
      if (e.column.dataField == 'useYn') e.cancel = false
      else e.cancel = true
    },
    onCheckValueChanged(value, cellInfo) {
      cellInfo.setValue(cellInfo.value === 'Y' ? 'N' : 'Y')
      this.fileGridData.selectRows(cellInfo.row.key, true)
      cellInfo.component.updateDimensions()
    },
    gridInit() {
      this.fileGridData.clearSelection()
      this.fileGridData.cancelEditData()
    },
    onContentReady(e) {
      this.files.forEach(element => {
        if (element.__created__) {
          e.component.selectRows(element.fileId, true)
        }
      })
    },
    onFocusedRowChanged(e) {
      this.$emit('focusedMasterChanged', this.masterDetailData)
    },
    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    getfileSize(size) {
      return (size / 1048576).toFixed(3) + 'MB'
    },
    getExtension(fileName) {
      let fileLen = fileName.length

      let lastDot = fileName.lastIndexOf('.')
      let extension = fileName.substring(lastDot + 1, fileLen)
      let baseName = fileName.substring(0, lastDot)
      return [baseName, extension]
    },
    search() {
      if (this.getCompId() == undefined) this.vToastify(this.$t('msgNoReqConditionsComp'), 'error')
      let searchParams = {
        targetId: this.masterDetailData.data.classifNo,
        targetType: this.masterDetailData.data.areaCd,
        compId: this.getCompId()
      }
      this.gridInit()
      getFile(searchParams)
        .then(res => {
          if (res.success) {
            this.files = []
            this.files = res.list
          }
        })
        .catch(error => {})
        .finally(() => {})
    },
    deleteCallBack(selectedRows) {
      var index = null
      selectedRows.forEach(key => {
        index = this.files.findIndex(obj => obj == key)
        this.files.splice(index, 1)
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
